import { render, staticRenderFns } from "./EditorialTabs.vue?vue&type=template&id=0e9c0a55&"
import script from "./EditorialTabs.vue?vue&type=script&lang=js&"
export * from "./EditorialTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports